import {
    RESET_COMPANY_AUTHENTICATION_OPEN_MODAL,
    RESET_COMPANY_AUTHENTICATION_CLOSE_MODAL,
    RESET_COMPANY_AUTHENTICATION_REQUEST,
    RESET_COMPANY_AUTHENTICATION_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    account: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case RESET_COMPANY_AUTHENTICATION_OPEN_MODAL:
            return { ...state, openModal: true, account: action.payload }

        case RESET_COMPANY_AUTHENTICATION_CLOSE_MODAL:
            return { ...state, openModal: false }

        case RESET_COMPANY_AUTHENTICATION_REQUEST:
            return { ...state, loading: true }

        case RESET_COMPANY_AUTHENTICATION_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "RESET_COMPANY_AUTHENTICATION"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};